import type { ComponentPropsWithoutRef, ElementType } from "react";

import { styled } from "simplydo/react/styled";

import { type UiColorPalette, useUiColor } from "../../utils/UIContext";

type ColorProps = { $color: UiColorPalette };

const StyledGhost = styled.button<ColorProps>`
  background-color: transparent;
  color: ${({ $color }) => $color.ink};
  box-shadow: none;

  &:hover:not(.is-disabled) {
    background-color: ${({ $color }) => $color.softer};
    color: ${({ $color }) => $color.ink};
  }

  &:active:not(.is-disabled) {
    background-color: ${({ $color }) => $color.soft};
    color: ${({ $color }) => $color.ink};
  }
`;

type Props = ComponentPropsWithoutRef<"button"> & {
  as?: ElementType;
  className?: string;
};

export function GhostButton({ as, className, ...props }: Props) {
  const uiColor = useUiColor();
  return (
    <StyledGhost as={as} className={className} $color={uiColor} {...props} />
  );
}
